// 7.1.13 ToObject(argument)
var defined = require('./$.defined');
module.exports = function(it){
  return Object(defined(it));
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/modules/$.to-object.js
// module id = ./node_modules/vue2-google-maps/node_modules/core-js/library/modules/$.to-object.js
// module chunks = 0